export default {
  title: 'Rendimiento semanal',
  messages_sent: 'Mensajes enviados',
  messages_delivered: 'Mensajes entregados',
  click_rate: 'Tasa media de clics',
  awaiting: 'Pendiente de confirmación',
  legend: {
    sent: 'Enviado',
    clicked: 'Clics',
    delivered: 'Entregado',
  },
  error_messages: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
